interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  const baseBtn =
    "flex items-center justify-center min-w-9 h-9 px-2 rounded-md text-sm font-medium border transition-colors cursor-pointer";
  const idle = "border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600 bg-background-50";
  const active = "border-primary-500 bg-primary-500 text-background-50";

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 mt-8">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className={`${baseBtn} ${idle} disabled:opacity-40 disabled:cursor-not-allowed`}
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line" />
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${baseBtn} ${p === page ? active : idle}`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className={`${baseBtn} ${idle} disabled:opacity-40 disabled:cursor-not-allowed`}
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}